import { combineReducers } from 'redux';
import { fromJS } from 'immutable';
import getApiReducer from '../../../common/utils/getApiReducer';
import {
  CANCEL_SESSION_FOR_MS,
  COMPLETE_SESSION,
  CONNECT_STRIPE_EXPRESS_ACCOUNT,
  GET_MS_ADMIN_SESSIONS,
  RESPOND_TO_SESSION,
} from './actions';

const sessionsReducer = getApiReducer(GET_MS_ADMIN_SESSIONS);
const sessions = (state, action) => {
  let nextState = sessionsReducer(state, action);

  if (action.type === `${RESPOND_TO_SESSION}_SUCCESS`) {
    const data = nextState.get('data');
    const index = data.findIndex(item => item.get('id') === action.json.id);

    return nextState.mergeIn(['data', index], fromJS(action.json));
  }

  if (action.type === `${CANCEL_SESSION_FOR_MS}_SUCCESS` || action.type === `${COMPLETE_SESSION}_SUCCESS`) {
    const data = state.get('data');
    const index = data.findIndex(item => item.get('id') === parseInt(action.sessionId, 10));

    nextState = nextState.set('data', data.delete(index));
  }

  return nextState;
};

export default combineReducers({
  cancelSession: getApiReducer(CANCEL_SESSION_FOR_MS),
  completeSession: getApiReducer(COMPLETE_SESSION),
  connectStripeExpressAccount: getApiReducer(CONNECT_STRIPE_EXPRESS_ACCOUNT),
  respondToSession: getApiReducer(RESPOND_TO_SESSION),
  sessions,
});



// WEBPACK FOOTER //
// ./src/subscription/movement-specialist-admin/redux/reducers.js